var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWBoardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1527_2715)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2439 9.41058C15.5694 9.08514 16.097 9.08514 16.4224 9.41058L18.9224 11.9106C19.2479 12.236 19.2479 12.7637 18.9224 13.0891L13.0891 18.9224C12.7637 19.2479 12.236 19.2479 11.9106 18.9224L9.41058 16.4224C9.08514 16.097 9.08514 15.5694 9.41058 15.2439L15.2439 9.41058ZM11.1783 15.8332L12.4998 17.1547L17.1547 12.4998L15.8332 11.1783L11.1783 15.8332Z",
    fill: "#FFA85D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07759 1.07759C1.28287 0.872314 1.58018 0.788661 1.86238 0.856778L13.9457 3.77344C14.2611 3.84958 14.5037 4.1019 14.5673 4.42008L15.8173 10.6701C15.872 10.9433 15.7865 11.2257 15.5894 11.4228L11.4228 15.5894C11.2257 15.7865 10.9433 15.872 10.6701 15.8173L4.42008 14.5673C4.1019 14.5037 3.84958 14.2611 3.77344 13.9457L0.856778 1.86238C0.788661 1.58018 0.872314 1.28287 1.07759 1.07759ZM2.79688 2.79688L5.26873 13.0374L10.5596 14.0956L14.0956 10.5596L13.0374 5.26873L2.79688 2.79688Z",
    fill: "#FFA85D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07757 1.07757C1.40301 0.752137 1.93065 0.752137 2.25608 1.07757L8.57775 7.39924C8.90319 7.72468 8.90319 8.25231 8.57775 8.57775C8.25231 8.90319 7.72468 8.90319 7.39924 8.57775L1.07757 2.25608C0.752137 1.93065 0.752137 1.40301 1.07757 1.07757Z",
    fill: "#FFA85D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1665 8.33317C8.70627 8.33317 8.33317 8.70627 8.33317 9.1665C8.33317 9.62674 8.70627 9.99984 9.1665 9.99984C9.62674 9.99984 9.99984 9.62674 9.99984 9.1665C9.99984 8.70627 9.62674 8.33317 9.1665 8.33317ZM6.6665 9.1665C6.6665 7.78579 7.78579 6.6665 9.1665 6.6665C10.5472 6.6665 11.6665 7.78579 11.6665 9.1665C11.6665 10.5472 10.5472 11.6665 9.1665 11.6665C7.78579 11.6665 6.6665 10.5472 6.6665 9.1665Z",
    fill: "#FFA85D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1527_2715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWBoardActive);
export default __webpack_public_path__ + "static/media/W_board_active.0c0478957e1a68c482f26b912e70a288.svg";
export { ForwardRef as ReactComponent };